import { createPinia } from 'pinia'
import { createApp } from 'vue'
import ElementPlus, { ElMessage } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import '@/styles/legacy-global.css'
import App from './App.vue'
import { loadRuntimeConfig, runtimeConfigKey } from '@/core/config/runtime'
import { configureHttp } from '@/core/http/client'
import { useAuthStore } from '@/stores/auth'
import { useUiStore } from '@/stores/ui'
import { useRouteStore } from '@/stores/route'
import router from '@/router'
import { clearAuthorizedRoutes, installAuthorizedRoutes } from '@/router/authorized'
import '@/styles/global.css'

export async function bootstrap() {
  const runtimeConfig = await loadRuntimeConfig()
  const app = createApp(App)
  const pinia = createPinia()
  const authStore = useAuthStore(pinia)
  const uiStore = useUiStore(pinia)
  const routeStore = useRouteStore(pinia)

  configureHttp(runtimeConfig, {
    onUnauthorized: () => {
      const sessionExpired = authStore.isAuthenticated
      authStore.clearSession()
      routeStore.clear()
      clearAuthorizedRoutes()
      if (sessionExpired) ElMessage.error('用户登录会话过期，请重新登录')
      void router.replace('/login')
    },
    onLoadingChange: (delta) => {
      if (delta === 1) uiStore.requestStarted()
      else uiStore.requestFinished()
    }
  })

  app.use(pinia)
  app.use(ElementPlus, { locale: zhCn })
  app.provide(runtimeConfigKey, runtimeConfig)

  await authStore.restore()
  routeStore.hydrate(authStore.menus)
  installAuthorizedRoutes(router, authStore.menus)
  app.use(router)
  await router.isReady()
  app.mount('#app')
}
